module.exports = __webpack_public_path__ + "static/funnels3-a9c5fc0e4be2546333cacff5dd6f3470.png";